import React from 'react';
import { Tabs } from 'antd';
import { useAuth } from '../../contexts/AuthContext';
import RolesManagement from '../../components/rbac/RolesManagement';
import PermissionsManagement from '../../components/rbac/PermissionsManagement';
import PageBreadcrumbs from '../../components/common/PageBreadcrumbs';

/**
 * RBAC Access Control Management Page
 * Main page for managing roles and permissions
 */
export default function AccessControl() {
  const { isSuperAdmin } = useAuth();

  if (!isSuperAdmin) {
    return (
      <div className="min-h-0 flex flex-col flex-1 h-full">
        <div className="flex-1 min-h-0 overflow-y-auto p-4 sm:p-6">
          <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
            <h2 className="text-xl font-semibold text-red-800 mb-2">Access Denied</h2>
            <p className="text-red-600">
              You don't have permission to access this module. Contact your administrator.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm overflow-hidden min-h-0 flex flex-col flex-1 h-full">
      <div className="shrink-0">
        <PageBreadcrumbs />
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto">
        {/* Tabs */}
        <Tabs
          defaultActiveKey="roles"
          className="rbac-tabs"
          items={[
            {
              key: 'roles',
              label: (
                <span className="inline-flex items-center px-2">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                  Roles
                </span>
              ),
              children: <RolesManagement />,
            },
            {
              key: 'permissions',
              label: (
                <span className="inline-flex items-center px-2">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                  Permissions
                </span>
              ),
              children: <PermissionsManagement />,
            },
          ]}
        />
        {/* Custom CSS for professional tabs */}
        <style>{`
        .rbac-tabs .ant-tabs-nav {
          margin-bottom: 0 !important;
          padding: 0 12px;
        }
        @media (min-width: 640px) {
          .rbac-tabs .ant-tabs-nav {
            padding: 0 24px;
          }
        }
        .rbac-tabs .ant-tabs-tab {
          border: none !important;
          background: transparent !important;
          padding: 12px 16px !important;
          margin-right: 4px !important;
          font-weight: 500 !important;
          color: #6b7280 !important;
          transition: all 0.2s !important;
        }
        .rbac-tabs .ant-tabs-tab:hover {
          color: #21B546 !important;
        }
        .rbac-tabs .ant-tabs-tab-active {
          color: #21B546 !important;
        }
        .rbac-tabs .ant-tabs-ink-bar {
          background: #21B546 !important;
          height: 3px !important;
        }
        .rbac-tabs .ant-tabs-content {
          padding: 12px;
        }
        @media (min-width: 640px) {
          .rbac-tabs .ant-tabs-content {
            padding: 24px;
          }
        }
      `}</style>
      </div>
    </div>
  );
}
